import {Component, Input} from '@angular/core';
import {NgForOf, NgIf, NgStyle} from '@angular/common';

@Component({
  selector: 'app-page-headline',
  standalone: true,
  imports: [
    NgStyle,
    NgIf,
    NgForOf
  ],
  templateUrl: './page-headline.component.html',
  styleUrl: './page-headline.component.scss'
})
export class BreadcrumbHeaderComponent {
  @Input() breadcrumbTitle: string = 'Tabelle Konfigurieren';
  @Input() breadcrumbs: { label: string, link?: string, iconClass?: string }[] = [
    { label: 'Tabellen', link: '#' },
    { label: 'Tabelle generieren', iconClass: 'fa fa-angle-double-right', link: '#' }
  ];
  @Input() mainTitle: string = 'Tabelle Konfigurieren';
  @Input() subtitle: string = `In unserem interaktiven Step-by-Step-Guide erstellen und konfigurieren Sie
      Ihre persönliche Lead-Tabelle. Durchlaufen Sie jeden Schritt und passen Sie die Tabelle
      exakt an Ihre Bedürfnisse an – schnell, intuitiv und effizient.`;
  @Input() titleImagePath: string = 'assets/images/saas1/title-logo.png';
  @Input() backgroundImage: string = 'assets/images/saas1/work-bg.png';
}